<template>
  <div class="filtBox">
    <!-- <el-form ref="searchForm" v-if="isFilter" :inline="true" label-width="100%"> -->
    <el-form ref="searchForm" :inline="true" label-width="100%">
      <slot name="otherCom"></slot>
      <el-form-item class="btnArea">
        <el-button class="btn-search" @click="search" size="medium" title="搜索"><i class="el-icon-search"> 搜索</i></el-button>
        <el-button class="btn-reset" @click="reset" size="medium" title="重置"><i class="el-icon-refresh"> 重置</i></el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  export default {
    props: {
      // isFilter: {
      //   type: Boolean,
      //   default: true
      // }
    },
    methods: {
      search() {
        this.$emit('search')
      },
      reset() {
        this.$emit('reset')
      },
      // isFilterView() {
      //   this.$emit('isFilterView')
      // }
    }

  }
</script>
<style rel="stylesheet/scss" lang="scss">
  $mar: 6px;
  $tbg: #f8f8f8;
  $coWhite: #fff;

  .filtBox {
    // width: 100%;
    // box-sizing: border-box;
    // -moz-box-sizing: border-box;
    // -webkit-box-sizing: border-box;

    margin: 0px 0px 10px 0px;
    padding: 0px 12px;
    background: #ffffff;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    display: flex;
    flex-flow: row;
    justify-content: space-between;

    .el-form {
      width: 100%;
      box-sizing: border-box;
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;
      // padding-top: 25px;
      // padding-top: 14px;
      padding-top: 18px;
      .el-input {
        // 原来的宽度
        width: 200px !important;
      }
      .el-select {
        // 原来的宽度
        width: 200px !important;
      }
    }

    .btnArea{
      float: right;
    }

    .el-button {
      border-radius: 4px;
      padding: 11px 15px;
      border: none;
    }

    .btn-search {
      background-color: #FA6241;
      color: #fff;
      &:hover {
        background-color: rgb(247, 143, 120);
      }
    }

    .btn-reset {
      background-color: #F99A1A;
      color: #fff;
      &:hover {
        background-color: rgb(248, 186, 105);
      }
    }
  }
</style>
